module.exports = __webpack_public_path__ + "static/media/cpg_theoutcome_anna.8e113381.png";